import { Component } from '@angular/core';

@Component({
    selector: 'valeri',
    template: require('./valeri.component.html'),
})

export class ValeriComponent {    

    constructor() {
    
    }

    navigateURL(url: string) {
        window.open(url, '_blank');
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/valeri/valeri.component.ts
 **/